/**
 * Tiny deterministic password hash for the mock auth.
 * NOT secure — data is local and the app explicitly runs with no backend.
 * Uses FNV-1a 32-bit over salt + password to get a short stable hex.
 */
const SALT = "neara-mock-v1";

const fnv1a = (str) => {
    let h = 0x811c9dc5;
    for (let i = 0; i < str.length; i++) {
        h ^= str.charCodeAt(i);
        h = (h + ((h << 1) + (h << 4) + (h << 7) + (h << 8) + (h << 24))) >>> 0;
    }
    return h.toString(16).padStart(8, "0");
};

export const hashPassword = (pw) => {
    const s = String(pw || "");
    // Two rounds with different prefixes so collisions across short inputs are rarer.
    return fnv1a(SALT + ":" + s) + fnv1a(s + ":" + SALT + ":" + s.length);
};

export const verifyPassword = (pw, hash) => hashPassword(pw) === hash;
